import { HttpAdapter } from "../../main/adapters/HttpAdapter";
import { MissingParamError } from "../../utils/erros/erros";

export class SerProGateway {
    HttpAdapter = new HttpAdapter();
    baseUrlSerpro = `${publicSettings.aws.baseUrls.dataSources}/serpro`;

    constructor() {}

    async getAuthorizationTerm({ accountingId, document, socialName }) {
        const response = await this.HttpAdapter.call(
            `${this.baseUrlSerpro}/generate-authorization-term`,
            {
                accountingId,
                document,
                socialName
            }
        );

        return response;
    }

    async integrateCompany(input) {
        const response = await this.HttpAdapter.call(
            `${this.baseUrlSerpro}/integrate`,
            input
        );

        return response;
    }

    async updateCompany(input) {
        const response = await this.HttpAdapter.call(
            `${this.baseUrlSerpro}/update`,
            input
        );

        return response;
    }

    /** `null` quando a rota falha: a tela volta ao desenho sem estado por empresa. */
    async getCompaniesStatus({ accountingId } = {}) {
        if (!accountingId) return null;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlSerpro}/companies-status`,
                { accountingId }
            );
            return Array.isArray(response?.companies) ? response : null;
        } catch (err) {
            return null;
        }
    }

    /** Competências dos últimos 12 meses e declarações de uma empresa; `null` se falhar. */
    async getCompanyHistory({ accountingId, companyId } = {}) {
        if (!accountingId || !companyId) return null;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlSerpro}/company-history`,
                { accountingId, companyId }
            );
            return Array.isArray(response?.periods) ? response : null;
        } catch (err) {
            return null;
        }
    }

    /**
     * O PDF de uma declaração, em base64; `null` quando o back responde sem ele (declaração apagada
     * ou de outra contabilidade). Falha de rede lança: não é o mesmo que o PDF não existir.
     */
    async getDeclarationPdf({ accountingId, declarationId } = {}) {
        if (!accountingId) throw new MissingParamError("accountingId");
        if (!declarationId) throw new MissingParamError("declarationId");
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlSerpro}/declaration-pdf`,
                { accountingId, declarationId }
            );
            return response?.contentBase64 ? response : null;
        } catch (error) {
            throw new Error(error.message || "Erro ao baixar o PDF da declaração");
        }
    }
}
